'use strict';
import {connect} from "../../../JavaScript/Utils";

class AsyncDeepLRedirect {

  anchors;
  constructor(rootElement) {
    this.anchors = rootElement.querySelectorAll('.language-menu li a');

    const matcher = /deepl=([^&]*)/;
    const match = window.location.search.match(matcher)

    if (match !== null && this.anchors) {

      this.anchors.forEach(anchor => {
        if (anchor.href) {
          const innerMatch = anchor.href.match(matcher);
          if (innerMatch !== null) {
            if (match[1] === innerMatch[1]) {
              anchor.parentElement.classList.add('active');
              const activeElement = rootElement.querySelector('#language_menu_current_active');
              if (activeElement) {
                activeElement.querySelector('.flag-icon')
                  .replaceWith(anchor.children[0].cloneNode(true));
              }
            } else {
              anchor.parentElement.classList.remove('active');
            }
          }
        } else {
          anchor.parentElement.classList.remove('active');
        }
      });
    }
  }

}

connect('.language-menu-dropdown', AsyncDeepLRedirect);
